// Copyright Prashant Vaghela, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import React from 'react';
import { createRoot } from 'react-dom/client';

import { applyTheme } from '@cloudscape-design/components/theming';

import { customTheme as theme } from '../../styles/theme';
import { App } from './root';

const { reset } = applyTheme({ theme });
if (!reset) {
  /* empty */
}

createRoot(document.getElementById('app')!).render(<App />);
